// extracted by mini-css-extract-plugin
export default {"container":"Success_container__D+9MH","title":"Success_title__ma6r+","icon":"Success_icon__XVMab","button":"Success_button__TUXn1"};